// assets/cart.js
// This handles the main cart page, not the cart drawer

document.addEventListener('DOMContentLoaded', () => {
  const cartForm = document.querySelector('.cart__contents');
  if (!cartForm) return;

  cartForm.addEventListener('click', async function (e) {
    // Quantity +/- Buttons
    if (e.target.matches('.quantity__button')) {
      e.preventDefault();
      const input = e.target.closest('.quantity-input').querySelector('.quantity__input');
      let newQty = parseInt(input.value, 10);
      if (e.target.name === 'plus') newQty++;
      if (e.target.name === 'minus') newQty = Math.max(1, newQty - 1);

      const variantId = input.dataset.quantityVariantId;
      
      // Update the input value first
      input.value = newQty;
      
      // Update the cart
      await updateCartLine(variantId, newQty);
    }

    // Remove Button
    if (e.target.matches('.button--tertiary')) {
      e.preventDefault();
      const row = e.target.closest('tr');
      const input = row.querySelector('.quantity__input');
      const variantId = input.dataset.quantityVariantId;
      await updateCartLine(variantId, 0);
    }
  });

  async function updateCartLine(variantId, quantity) {
    try {
      // Send the update request to the cart
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ 
          id: String(variantId), 
          quantity: quantity 
        }),
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const cartData = await response.json();
      
      // Reload the cart section with the updated data
      fetch('/cart')
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newCartForm = doc.querySelector('.cart__contents');
          if (newCartForm) {
            cartForm.innerHTML = newCartForm.innerHTML;
          }
        });
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  }
});